/* The Spine Bookshop redesign: add-to-cart on custom cards, and the book search page.
   Book search reads the Spine Book Engine (read-only); carts go through Shopify's own /cart/add.js. */
(function () {
  'use strict';

  var ENGINE = (window.SpineConfig && window.SpineConfig.engine) || 'https://spine-book-engine.tyler-162.workers.dev';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fetchT(url, ms) {
    var ctl = window.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { if (ctl) ctl.abort(); }, ms || 8000);
    return fetch(url, ctl ? { signal: ctl.signal } : {}).then(function (r) { clearTimeout(t); if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }, function (e) { clearTimeout(t); throw e; });
  }
  function numericId(gid) { return String(gid || '').split('/').pop(); }
  function money(p) {
    var n = Number(p);
    if (!isFinite(n) || n <= 0) return '';
    return '$' + n.toFixed(2);
  }

  /* ---------------- add to cart ---------------- */
  function addToCart(variantId, btn) {
    var drawer = document.querySelector('cart-drawer');
    var notification = document.querySelector('cart-notification');
    var target = drawer || notification;
    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (target && typeof target.getSectionsToRender === 'function') {
      body.sections = target.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add to cart');
        if (target && res.j.sections && typeof target.renderContents === 'function') {
          if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          target.renderContents({ id: variantId, key: res.j.items && res.j.items[0] && res.j.items[0].key, sections: res.j.sections });
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (btn) { btn.classList.add('is-added'); btn.textContent = 'Added'; }
        document.dispatchEvent(new CustomEvent('spine:cart-added', { detail: { variantId: variantId } }));
      })
      .catch(function (e) {
        if (btn) { btn.textContent = 'Unavailable'; btn.title = e.message; }
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
      });
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-sp-add]');
    if (!btn) return;
    ev.preventDefault();
    addToCart(btn.getAttribute('data-sp-add'), btn);
  });

  /* ---------------- book search page ---------------- */
  function bookCard(b) {
    var vid = numericId(b.variantId);
    var cover = b.coverUrl
      ? '<img src="' + esc(b.coverUrl) + '" alt="" loading="lazy" width="320" height="480">'
      : '';
    var by = b.author ? '<div class="sp-by">' + esc(b.author) + '</div>' : '';
    var canBuy = b.shipsOnly || b.quantity > 0;
    var stock = b.shipsOnly ? '<div class="sp-stock sp-stock--ship">Ships to you</div>'
      : b.quantity > 0 ? '<div class="sp-stock">On our shelf' + (b.condition ? ' · ' + esc(b.condition) : '') + '</div>' : '';
    return '<article class="sp-book sp-res">' +
      '<a class="sp-cover" href="#" data-sp-detail="' + esc(b.variantId) + '" aria-label="' + esc(b.title) + ' details">' + cover + '</a>' +
      '<h3><a href="#" data-sp-detail="' + esc(b.variantId) + '">' + esc(b.title) + '</a></h3>' + by + stock +
      '<div class="sp-row"><span class="sp-price">' + money(b.price) + '</span>' +
      (canBuy ? '<button type="button" class="sp-add" data-sp-add="' + esc(vid) + '">Add to cart</button>' : '') +
      '</div></article>';
  }

  function skeleton(n) {
    var s = '';
    for (var i = 0; i < n; i++) s += '<article class="sp-book sp-skel"><div class="sp-cover"></div><h3>&nbsp;</h3></article>';
    return s;
  }

  function initSearch(root) {
    var form = root.querySelector('form');
    var input = root.querySelector('input[name="q"]');
    var status = root.querySelector('.sp-status');
    var list = root.querySelector('.sp-reslist');
    var group = root.querySelector('.sp-resgroup');
    var shipGroup = root.querySelector('.sp-shipgroup');
    var shipList = shipGroup && shipGroup.querySelector('.sp-shiplist');
    window.__spSearchReady = true;
    if (document.documentElement.classList.contains('sp-search-off')) return;
    var params = new URLSearchParams(window.location.search);
    var q = (params.get('q') || '').trim();
    if (input) input.value = q;

    function showShopifyFallback() { document.documentElement.classList.remove('sp-search-js'); }

    function run(term) {
      if (shipGroup) shipGroup.hidden = true;
      if (!term) { group.hidden = true; status.textContent = ''; return; }
      group.hidden = false;
      list.innerHTML = skeleton(8);
      status.textContent = 'Searching our shelves for “' + term + '”…';
      var ctl = window.AbortController ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 9000);
      fetch(ENGINE + '/api/discover/local?q=' + encodeURIComponent(term), ctl ? { signal: ctl.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) {
          clearTimeout(timer);
          var books = (data.local || []).filter(function (b) { return b.quantity > 0; });
          var shipped = shipGroup ? (data.shipped || []) : [];
          if (shipped.length) {
            shipList.innerHTML = shipped.map(bookCard).join('');
            shipGroup.hidden = false;
          }
          if (!books.length && shipped.length) {
            list.innerHTML = '';
            group.hidden = true;
            root.querySelector('.sp-noresults').hidden = true;
            status.textContent = 'Nothing on our shelves for “' + term + '”, but we can ship ' + (shipped.length === 1 ? 'this one' : 'these') + ' to you.';
            return;
          }
          if (!books.length) {
            list.innerHTML = '';
            status.textContent = '';
            group.hidden = true;
            root.querySelector('.sp-noresults').hidden = false;
            root.querySelector('.sp-noresults .sp-term').textContent = term;
            showShopifyFallback();   /* gift cards, totes and other non-book items live in Shopify's results */
            return;
          }
          root.querySelector('.sp-noresults').hidden = true;
          status.textContent = books.length + (books.length === 1 ? ' book' : ' books') + ' on our shelves for “' + term + '”' +
            (shipped.length ? ', plus ' + shipped.length + ' more we can ship to you' : '');
          list.innerHTML = books.map(bookCard).join('');
        })
        .catch(function () {
          clearTimeout(timer);
          group.hidden = true;
          status.textContent = 'Our book search is taking a break — here are results from the store instead.';
          showShopifyFallback();
        });
    }

    run(q);
  }

  /* ---------------- detail dialog ---------------- */
  var dialog;
  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'sp-dialog spine';
    dialog.innerHTML = '<button type="button" class="sp-x" aria-label="Close">×</button><div class="sp-dbody"></div>';
    document.body.appendChild(dialog);
    dialog.querySelector('.sp-x').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    return dialog;
  }

  function productUrl(b) {
    var pid = numericId(b.productId);
    var url = '/search/suggest.json?q=' + encodeURIComponent(b.rawTitle || b.title) + '&resources[type]=product&resources[limit]=10';
    return fetch(url).then(function (r) { return r.json(); }).then(function (j) {
      var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
      var hit = ps.filter(function (p) { return String(p.id) === pid; })[0];
      return hit ? hit.url.split('?')[0] : null;
    }).catch(function () { return null; });
  }

  function openDetail(variantGid) {
    var d = ensureDialog();
    var body = d.querySelector('.sp-dbody');
    body.innerHTML = '<p class="sp-status">Loading…</p>';
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    fetch(ENGINE + '/api/book/detail?variant=' + encodeURIComponent(variantGid))
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (b) {
        var m = b.meta || {};
        var facts = [m.format, m.publisher, (m.publishDate || '').slice(0, 4), m.pages ? m.pages + ' pages' : '', b.identifier ? 'ISBN ' + b.identifier : '']
          .filter(Boolean).map(esc).join(' · ');
        var subj = (m.subjects || []).map(function (s) {
          return '<li><a href="/search?q=' + encodeURIComponent(s) + '">' + esc(s) + '</a></li>';
        }).join('');
        var desc = m.description ? esc(m.description).split(/\n{1,}/).map(function (p) { return '<p>' + p + '</p>'; }).join('') : '';
        body.innerHTML =
          '<div class="sp-dgrid"><div class="sp-cover">' + (b.coverUrl ? '<img src="' + esc(b.coverUrl) + '" alt="">' : '') + '</div>' +
          '<div><h2>' + esc(b.title) + '</h2>' + (b.author ? '<div class="sp-by">by ' + esc(b.author) + '</div>' : '') +
          (b.shipsOnly ? '<div class="sp-stock sp-stock--ship">Not on our shelf, but we can ship it to you. Usually arrives in about a week.</div>'
            : b.quantity > 0 ? '<div class="sp-stock">On our shelf · ready for pickup or shipping</div>' : '') +
          '<div class="sp-drow"><span class="sp-price">' + money(b.price) + '</span>' +
          ((b.shipsOnly || b.quantity > 0) ? '<button type="button" class="sp-btn sp-btn--y" data-sp-add="' + esc(numericId(b.variantId)) + '">Add to cart</button>' : '') +
          '<a class="sp-more sp-plink" hidden>View full page →</a></div>' +
          (facts ? '<p class="sp-facts1">' + facts + '</p>' : '') +
          (desc ? '<div class="sp-ddesc">' + desc + '</div>' : '') +
          (subj ? '<ul class="sp-tags">' + subj + '</ul>' : '') + '</div></div>';
        productUrl(b).then(function (u) {
          var a = body.querySelector('.sp-plink');
          if (u && a) { a.href = u; a.hidden = false; }
        });
      })
      .catch(function () { body.innerHTML = '<p>Sorry — we couldn’t load this book’s details. Please try again.</p>'; });
  }

  document.addEventListener('click', function (ev) {
    var a = ev.target.closest('[data-sp-detail]');
    if (!a) return;
    ev.preventDefault();
    openDetail(a.getAttribute('data-sp-detail'));
  });


  /* ---------------- Withfriends (events, tickets, memberships) in a popup ---------------- */
  var wfDialog;
  function openWithfriends(url, title) {
    if (!wfDialog) {
      wfDialog = document.createElement('dialog');
      wfDialog.className = 'sp-wf spine';
      wfDialog.innerHTML = '<div class="sp-wf-bar"><b class="sp-wf-title"></b><a class="sp-wf-out" target="_blank" rel="noopener">Open in a new tab ↗</a><button type="button" class="sp-x" aria-label="Close">×</button></div><iframe title="Events" loading="lazy" allow="payment *; clipboard-write"></iframe>';
      document.body.appendChild(wfDialog);
      wfDialog.querySelector('.sp-x').addEventListener('click', function () { wfDialog.close(); });
      wfDialog.addEventListener('click', function (e) { if (e.target === wfDialog) wfDialog.close(); });
      wfDialog.addEventListener('close', function () { wfDialog.querySelector('iframe').src = 'about:blank'; });
    }
    wfDialog.querySelector('.sp-wf-title').textContent = title || 'Events at The Spine';
    wfDialog.querySelector('.sp-wf-out').href = url;
    wfDialog.querySelector('iframe').src = url;
    if (typeof wfDialog.showModal === 'function') wfDialog.showModal(); else window.open(url, '_blank');
  }
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest('a[href*="withfriends.co/"]');
    if (!a || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button === 1) return;
    if (a.hasAttribute('data-sp-no-popup') || a.classList.contains('sp-wf-out')) return;
    if (calDialog && calDialog.open && a.closest('.sp-cal')) calDialog.close();
    if (a.closest('.sp-evd-desc')) return;
    ev.preventDefault();
    var t = a.getAttribute('data-sp-popup-title') || (/\/event\//.test(a.href) ? 'Event details' : 'Events at The Spine');
    var eid = eventIdFrom(a.href);
    if (eid) { openEventDetail(eid, a.href, t); return; }
    if (/withfriends\.co\/the_spine_bookshop\/events/i.test(a.href)) { openCalendar(); return; }
    openWithfriends(a.href, t);
  });




  /* ---------------- staff picks from the admin app ---------------- */
  function initLivePicks(sec) {
    var limit = parseInt(sec.getAttribute('data-sp-live-picks'), 10) || 6;
    var grid = sec.querySelector('.sp-picks');
    var hasBlocks = grid && grid.children.length > 0;
    fetchT(ENGINE + '/api/staff-picks?limit=' + limit, 8000).then(function (d) {
      var picks = d.picks || [];
      if (!picks.length) { if (!hasBlocks) sec.hidden = true; sec.classList.remove('sp-picks-pending'); return; }
      grid.innerHTML = picks.map(function (p) {
        return '<article class="sp-pick">' +
          '<a class="sp-cover" href="#" data-sp-detail="' + esc(p.variantId) + '" aria-label="' + esc(p.title) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div><div class="sp-who"><span class="sp-av" style="background:' + esc(p.color) + '">' + esc(String(p.staff).charAt(0)) + '</span><div><b>' + esc(p.staff) + '’s pick</b><span>' + esc(p.specialty) + '</span></div></div>' +
          '<h3><a href="#" data-sp-detail="' + esc(p.variantId) + '">' + esc(p.title) + '</a></h3>' + (p.author ? '<div class="sp-by">' + esc(p.author) + '</div>' : '') +
          (p.note ? '<div class="sp-note"><p>' + esc(p.note) + '</p></div>' : '') +
          '<div class="sp-row"><span class="sp-price">' + money(p.price) + '</span><button type="button" class="sp-add" data-sp-add="' + esc(p.variant) + '">Add to cart</button></div></div></article>';
      }).join('');
      sec.classList.remove('sp-picks-pending');
    }).catch(function () { if (!hasBlocks) sec.hidden = true; sec.classList.remove('sp-picks-pending'); });
  }

  /* ---------------- event details in The Spine's own design ---------------- */
  var evDialog, coDialog;
  function eventIdFrom(url) { var m = String(url).match(/withfriends\.co\/event\/(\d+)/i); return m ? m[1] : null; }
  function openCheckout(id, title) {
    if (!coDialog) {
      coDialog = document.createElement('dialog');
      coDialog.className = 'sp-wf sp-co spine';
      coDialog.innerHTML = '<div class="sp-wf-bar"><b class="sp-wf-title"></b><button type="button" class="sp-x" aria-label="Close">×</button></div><iframe title="RSVP" allow="payment *"></iframe><p class="sp-co-help">Trouble with the form? <a target="_blank" rel="noopener" data-sp-no-popup>Open it in a new window</a>.</p>';
      document.body.appendChild(coDialog);
      coDialog.querySelector('.sp-x').addEventListener('click', function () { coDialog.close(); });
      coDialog.addEventListener('click', function (e) { if (e.target === coDialog) coDialog.close(); });
      coDialog.addEventListener('close', function () { coDialog.querySelector('iframe').src = 'about:blank'; });
    }
    var url = 'https://withfriends.co/Flow/Buy_Tickets:Target=' + id + ',Target_Type=Event,force_minimal=1';
    coDialog.querySelector('.sp-wf-title').textContent = title || 'RSVP';
    coDialog.querySelector('iframe').src = url;
    coDialog.querySelector('.sp-co-help a').href = url;
    coDialog.showModal();
  }
  function openEventDetail(id, fallbackUrl, fallbackTitle) {
    if (!evDialog) {
      evDialog = document.createElement('dialog');
      evDialog.className = 'sp-evd spine';
      evDialog.innerHTML = '<button type="button" class="sp-x" aria-label="Close">×</button><div class="sp-evd-body"></div>';
      document.body.appendChild(evDialog);
      evDialog.querySelector('.sp-x').addEventListener('click', function () { evDialog.close(); });
      evDialog.addEventListener('click', function (e) { if (e.target === evDialog) evDialog.close(); });
    }
    var body = evDialog.querySelector('.sp-evd-body');
    body.innerHTML = '<p class="sp-status">Loading…</p>';
    evDialog.showModal();
    fetchT(ENGINE + '/api/events/detail?id=' + encodeURIComponent(id), 8000).then(function (e) {
      var p = evParts({ date: null, when: e.when });
      var dm = String(e.when || '').match(/^([A-Za-z]+),\s+([A-Za-z]+)\s+(\d{1,2})/);
      var big = dm ? dm[2].slice(0, 3) + ' ' + dm[3] : '';
      var dow = dm ? dm[1] : '';
      var tm = (String(e.when || '').match(/at\s+(\d{1,2}:\d{2}\s*[AP]M)/i) || [])[1] || '';
      var where = e.where || '244 S. Lowry St, Smyrna';
      var own = OWN_ADDRESS.test(where);
      var maps = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(where);
      var cta = /ticket|buy/i.test(e.action || '') ? 'Get tickets' : 'RSVP';
      body.innerHTML =
        '<div class="sp-evd-top">' +
          (e.image ? '<div class="sp-evd-art"><img src="' + esc(e.image) + '" alt=""></div>' : '') +
          '<div class="sp-evd-info">' +
            '<div class="sp-evd-date"><span class="sp-evd-big">' + esc(big) + '</span><span>' + esc(dow) + (tm ? ' · ' + esc(tm.replace(/:00\s*/, ' ').toLowerCase()) : '') + '</span></div>' +
            '<h2>' + esc(e.title) + '</h2>' +
            '<p class="sp-evd-where">' + esc(own ? 'At the shop · 244 S. Lowry St, Smyrna' : where) + '</p>' +
            '<div class="sp-evd-actions">' +
              (e.price ? '<span class="sp-evd-price">' + esc(e.price) + '</span>' : '') +
              '<button type="button" class="sp-btn sp-btn--y" data-sp-rsvp="' + esc(id) + '">' + cta + '</button>' +
              '<a class="sp-btn sp-btn--o" href="' + esc(maps) + '" target="_blank" rel="noopener">Get directions</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
        (e.descriptionHtml ? '<div class="sp-evd-desc">' + e.descriptionHtml + '</div>' : '');
      body.querySelector('[data-sp-rsvp]').addEventListener('click', function () { openCheckout(id, e.title); });
    }).catch(function () { evDialog.close(); openWithfriends(fallbackUrl, fallbackTitle); });
  }

  /* ---------------- live events from Withfriends (via the Spine Book Engine) ---------------- */
  var EVENTS_PROMISE = null;
  function getEvents() {
    if (!EVENTS_PROMISE) EVENTS_PROMISE = fetchT(ENGINE + '/api/events', 8000).then(function (d) { if (!d.events || !d.events.length) throw new Error('none'); return d; })
      .catch(function (e) { EVENTS_PROMISE = null; throw e; });
    return EVENTS_PROMISE;
  }
  var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MONTH_FULL = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  function evParts(e) {
    var d = e.date ? new Date(e.date + 'T12:00:00Z') : null;
    var tm = (String(e.when || '').match(/at\s+(\d{1,2}:\d{2}\s*[AP]M)/i) || [])[1] || '';
    return { d: d, day: d ? DOW[d.getUTCDay()] + ', ' + MON[d.getUTCMonth()] + ' ' + d.getUTCDate() : (e.when || ''), time: tm.replace(/:00\s*/, ' ').toLowerCase().replace(/\s+/g, ' ') };
  }
  var OWN_ADDRESS = /244 S\.? Lowry/i;
  function groupRecurring(events) {
    var by = {}, order = [];
    events.forEach(function (e) { var k = e.title.toLowerCase(); if (!by[k]) { by[k] = []; order.push(k); } by[k].push(e); });
    return order.map(function (k) { return by[k]; });
  }
  function evItem(group) {
    var e = group[0], p = evParts(e), more = group.length - 1;
    var weekly = '';
    if (more >= 2 && p.d) {
      var same = group.every(function (x) { return x.date && new Date(x.date + 'T12:00:00Z').getUTCDay() === p.d.getUTCDay(); });
      if (same) weekly = 'Every ' + ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][p.d.getUTCDay()];
    }
    var note = weekly ? weekly + ' · next one ' + p.day : (more ? 'Also on ' + group.slice(1, 3).map(function (x) { return evParts(x).day.replace(/^\w+, /, ''); }).join(', ') + (more > 2 ? ' and ' + (more - 2) + ' more' : '') : '');
    var where = e.where && !OWN_ADDRESS.test(e.where) ? e.where : '';
    return '<div class="sp-ev sp-ev--live">' +
      '<div class="sp-when">' + esc(weekly ? weekly.replace('Every ', '') + 's' : p.day) + '<small>' + esc(p.time || '') + '</small></div>' +
      '<div><h3><a href="' + esc(e.url) + '" data-sp-popup-title="' + esc(e.title) + '">' + esc(e.title) + '</a></h3>' +
      (note ? '<p>' + esc(note) + '</p>' : '') + (where ? '<p>' + esc(where) + '</p>' : '') +
      '<a href="' + esc(e.url) + '" data-sp-popup-title="' + esc(e.title) + '">Details and tickets →</a></div>' +
      (e.image ? '<a class="sp-ev-img" href="' + esc(e.url) + '" data-sp-popup-title="' + esc(e.title) + '" aria-hidden="true" tabindex="-1"><img src="' + esc(e.image) + '" alt="" loading="lazy"></a>' : '') +
      '</div>';
  }
  function initLiveEvents(list) {
    var limit = parseInt(list.getAttribute('data-sp-live-events'), 10) || 6;
    getEvents().then(function (d) {
      var groups = groupRecurring(d.events).slice(0, limit);
      list.innerHTML = groups.map(evItem).join('');
      list.classList.add('is-live');
    }).catch(function () { /* keep the events typed into the theme editor */ });
  }
  var calDialog;
  function openCalendar() {
    getEvents().then(function (d) {
      if (!calDialog) {
        calDialog = document.createElement('dialog');
        calDialog.className = 'sp-wf sp-cal spine';
        calDialog.innerHTML = '<div class="sp-wf-bar"><b class="sp-wf-title">Events at The Spine</b><button type="button" class="sp-x" aria-label="Close">×</button></div><div class="sp-cal-body"></div>';
        document.body.appendChild(calDialog);
        calDialog.querySelector('.sp-x').addEventListener('click', function () { calDialog.close(); });
        calDialog.addEventListener('click', function (e) { if (e.target === calDialog) calDialog.close(); });
      }
      var html = '', cur = '';
      d.events.forEach(function (e) {
        var p = evParts(e), m = p.d ? MONTH_FULL[p.d.getUTCMonth()] + ' ' + p.d.getUTCFullYear() : 'Coming up';
        if (m !== cur) { html += (cur ? '</ul>' : '') + '<h3 class="sp-cal-month">' + esc(m) + '</h3><ul class="sp-cal-list">'; cur = m; }
        html += '<li><a href="' + esc(e.url) + '" data-sp-popup-title="' + esc(e.title) + '">' + (e.image ? '<img src="' + esc(e.image) + '" alt="" loading="lazy">' : '<span class="sp-cal-ph"></span>') +
          '<span><b>' + esc(e.title) + '</b><small>' + esc(p.day + (p.time ? ' · ' + p.time : '')) + (e.where && !OWN_ADDRESS.test(e.where) ? ' · ' + esc(e.where) : '') + '</small></span><em>Details →</em></a></li>';
      });
      calDialog.querySelector('.sp-cal-body').innerHTML = html + '</ul>';
      calDialog.showModal();
    }).catch(function () { openWithfriends('https://withfriends.co/the_spine_bookshop/events', 'Events at The Spine'); });
  }
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest('[data-sp-calendar]');
    if (!a || ev.metaKey || ev.ctrlKey) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    openCalendar();
  }, true);

  document.addEventListener('spine:cart-added', function () { if (dialog && dialog.open) dialog.close(); });

  function boot() {
    var root = document.getElementById('sp-book-search');
    if (root) initSearch(root);
    document.querySelectorAll('[data-sp-live-events]').forEach(initLiveEvents);
    document.querySelectorAll('[data-sp-live-picks]').forEach(initLivePicks);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
